import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import {
  GET_AFFILIATE_SETTING, POST_AFFILIATE_SETTING,
} from '../actions/affiliate/action_types';

import actions from '../actions/affiliate';
import rf from '../../requests/RequestFactory';
import utils from '../../common/utils';

function* fetchAllSetting(action) {
  try {
    const data = yield call((params) => rf.getRequest('AffiliateRequest').fetchSetting(), action.params);
    if (data.error.code === 200) {
      yield put(actions.setAffiliateSetting(data.data));
    }
  } catch (err) {
    console.log(err, 'err');
  }
}

function* postSetting(action) {
  try {
    const data = yield call((params) => rf.getRequest('AffiliateRequest').postSetting(action.data), action.params);
    if (data === 'Success') {
      yield put(actions.getAffiliateSetting(data));
      yield utils.showNotification('Thông báo', 'Thành công', 'success');
      yield action.callback();
    }
  } catch (err) {
    yield utils.showNotification('Thông báo', 'Thất bại', 'error');
    yield action.callback();
    console.log(err, 'err');
  }
}

function* watchAffiliate() {
  yield takeLatest(GET_AFFILIATE_SETTING, fetchAllSetting);
  yield takeLatest(POST_AFFILIATE_SETTING, postSetting);
}

export default function* rootSaga() {
  yield all([fork(watchAffiliate)]);
}
